let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jB6NT")).then(() => parcelRequire('7aMFL'));